import BossModel from "@/models/BossModel";

export default class Day extends BossModel {

    static apiUrl = 'product/detail/composition/purchase/day';

    static entity = 'productDetailCompositionPurchaseDays';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_detail_composition_purchase_id: this.number(null),
            day_of_week: this.number(null),
        }
    }
}
